/*
 * Copyright (c) Worldline 2022.
 */

import {Component, OnInit} from '@angular/core';
import {SessionService} from "../../services/session.service";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-timeout-popup',
  templateUrl: './timeout-popup.component.html'
})
export class TimeoutPopupComponent implements OnInit {

  constructor(private sessionService: SessionService, private activeModal: NgbActiveModal) {
  }

  canRedirect: any

  private redirectionStrategy: any

  ngOnInit(): void {
    this.redirectionStrategy = this.sessionService.getErrorRedirectionStrategy();

    this.canRedirect = this.redirectionStrategy.canRedirect;
  }

  error() {
    if (this.redirectionStrategy.canRedirect) {
      this.activeModal.close(this.redirectionStrategy.url);
    }
  };

}
